import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';

export class RegistrationMaintenanceError extends ExpectedError {
  static override _class = 'RegistrationMaintenanceError';

  public constructor() {
    super('RegistrationMaintenanceError', { translationKey: 'REGISTRATION_MAINTENANCE_ERROR' });
  }
}
